module.exports = __webpack_public_path__ + "static/media/icon-youtube.1f2c7e1f.svg";